/**
 * Form Utilities Service
 * 
 * Handles checkout form utility functions for field validation and requirements.
 * Follows Single Responsibility Principle - only concerned with form field manipulation.
 */

/**
 * Sets the required attribute on credit card fields
 * @param {boolean} required - Whether credit card fields should be required
 */
export function setCreditCardFieldsRequired(required) {
  const cardFields = document.querySelectorAll('.card-data-field')
  cardFields.forEach(field => {
    field.required = required
  })
}

/**
 * Validates that all required credit card fields are filled
 * @returns {boolean} True if all required fields are valid
 */
export function validateCreditCardFields() {
  const cardNumber = document.querySelector('input[name="card[number]"]')
  const cardCVV = document.querySelector('input[name="card[cvv]"]')
  const cardMonth = document.querySelector('select[name="card[expires_on][exp_date(2i)]"]')
  const cardYear = document.querySelector('select[name="card[expires_on][exp_date(1i)]"]')

  const numberValid = cardNumber?.value?.trim()
  const cvvValid = cardCVV?.value?.trim()
  const monthValid = cardMonth?.value
  const yearValid = cardYear?.value

  return !!(numberValid && cvvValid && monthValid && yearValid)
}

/**
 * Checks if credit card payment is selected
 * @returns {boolean} True if credit card payment is selected
 */
export function isCreditCardPaymentSelected() {
  const cardRadio = document.getElementById('payment_choice_credit_card')
  return cardRadio?.checked || false
}

/**
 * Checks if terms and conditions are accepted
 * @returns {boolean} True if terms are accepted
 */
export function areTermsAccepted() {
  const termsCheckbox = document.getElementById('customer_accepted_order_terms')
  return termsCheckbox?.checked || false
}
